import { Component, EventEmitter, Input, Output, inject } from "@angular/core";
import { UserService } from "@app/user/user-profile/shared/user.service";
import { DocumentMethods } from "@methods/DocumentMethods";
import { DocumentModel } from "@models/documents/documentmodel";
import { MatIconModule } from "@angular/material/icon";
import { TranslocoPipe } from "@jsverse/transloco";
import { FileDropDirective } from "@app/shared/directives/file-drop.directive";
import { EffBrowseFilesButtonComponent } from "../browse-files-button/browse-files-button.component";

export class DroppedDocuments {
    IsBrowse: boolean;
    Documents: DocumentModel[];
}

@Component({
    selector: "eff-drop-files-area",
    templateUrl: "./eff-drop-files-area.component.html",
    styleUrls: ["./eff-drop-files-area.component.scss"],
    imports: [MatIconModule, TranslocoPipe, FileDropDirective, EffBrowseFilesButtonComponent]
})
export class EffDropFilesAreaComponent {
    private _userDS = inject(UserService);

    @Input() allowedFileExtensions: string;
    @Input() allowDrop: boolean = false;
    @Output() onDroppedFiles: EventEmitter<DroppedDocuments> = new EventEmitter();

    async fileDropHandler(files: File[], isBrowse: boolean) {
        if (this.allowDrop) {
            const droppedDocuments = DocumentMethods.convertFileListToDocumentModel(
                files,
                await this._userDS.getUserName()
            );

            this.onDroppedFiles.emit({ IsBrowse: isBrowse, Documents: droppedDocuments });
        }
    }
}
